import React from 'react';
import PropTypes from 'prop-types';
var DropdownHeader = function DropdownHeader(props) {
  var icon = props.icon,
    label = props.label,
    center = props.center;
  return /*#__PURE__*/React.createElement("li", {
    className: "dropdown-header ".concat(center ? 'center' : '')
  }, /*#__PURE__*/React.createElement("span", {
    className: 'dropdown-header-text'
  }, icon && /*#__PURE__*/React.createElement("span", {
    className: 'margin-right-5'
  }, icon), label));
};
DropdownHeader.defaultProps = {
  center: true
};
DropdownHeader.propTypes = {
  icon: PropTypes.string,
  center: PropTypes.bool,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node])
};
export default DropdownHeader;